import React, {useEffect} from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import config from "../../../config";
import { useDispatch } from "react-redux";
import { BookingSelectedServicesData, BookingStepName, NextStep, BookingSelectedSubscriptionData } from "store/slices/bookingSlice";
import { useSelector } from "react-redux";
import {restrictSalonOnlineVoucherSale} from '../../../config/config';

const Step1 = (props) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const isBookingStep = props.isBookingStep;
  const isBookingApi = useSelector((state) => state.booking.isBookingApi);

  useEffect(() => {
    if(isBookingApi?.subscription_id){
     dispatch(BookingStepName("BuySubscription"));
      dispatch(BookingSelectedSubscriptionData(isBookingApi?.subscription));
      dispatch(NextStep(2));
    }
  }, []);
  
  return (
    <div className="row mb-4">
      <div className="col-lg-8 mx-auto">
        <div className="booking-description text-center mb-4">
          <p>
            <b> {isBookingApi.salon.business_name} </b> {isBookingApi.salon.business_address}
          </p>
        </div>
        <div className="online-booking-content bg-white">
          <div className="booking-logo d-flex justify-content-center">
            <img className="rounded booking-link-logo" src={isBookingApi.salon.logo_url} width="136" alt="" />
          </div>
          <React.Fragment>
            <div className="please-sele">
              <a className="select-btn " style={{ textDecoration: 'none' }}>{t("Please select")}</a>
            </div>
            <div className="items-list">
              <ul className="m-0 p-0">
                <li
                  className="items-option"
                  role="button"
                  onClick={() => {
                    // formik.setFieldValue("bookingStepName", "Book a Services");
                    dispatch(BookingStepName("BookServices"));
                    dispatch(BookingSelectedServicesData({ id: 1, category_id: "", service_id: "", staff_id: "", resource_item_id: "", datetime: "", duration: "", padding_time: "", durationWithPadding: "", parentAppointmentEndTime: "" }));
                    dispatch(NextStep(isBookingStep));
                  }}
                >
                  <div className="d-flex justify-content-between align-items-center">
                    <h6 className="mb-0">
                      <a>
                        <img src={config.imagepath + "service-icon.png"} alt="" className="me-3" width="21" />
                        {t("Book a Service")}
                      </a>
                    </h6>
                  </div>
                </li>
                
                {!restrictSalonOnlineVoucherSale?.includes(isBookingApi.salon.id) && ( 
                  <li
                    className="items-option"
                    role="button"
                    onClick={() => {
                      // formik.setFieldValue("bookingStepName", "Buy a Voucher");
                      dispatch(BookingStepName("BuyVoucher"));
                      dispatch(NextStep(isBookingStep));
                    }}
                  >
                    <div className="d-flex justify-content-between align-items-center">
                      <h6 className="mb-0">
                        <a>
                          <img src={config.imagepath + "vo-icon.png"} alt="" className="me-3" width="21" />
                          {t("Buy a Voucher")}
                        </a>
                      </h6>
                    </div>
                  </li>
                )}
               
                {isBookingApi && isBookingApi.total_membership_count > 0 && (
                  <li
                    className="items-option"
                    role="button"
                    onClick={() => {
                      // formik.setFieldValue("bookingStepName", "Buy a Membership");
                      dispatch(BookingStepName("BuyMembership"));
                      dispatch(NextStep(isBookingStep));
                    }}
                  >
                    <div className="d-flex justify-content-between align-items-center">
                      <h6 className="mb-0">
                        <a>
                          <img src={config.imagepath + "member-icon.png"} alt="" className="me-3" width="21" />
                          {t("Buy a Package")}
                        </a>
                      </h6>
                    </div>
                  </li>
                )}
                {isBookingApi && (isBookingApi?.salon?.salonsubscription?.[0]?.package_type_id==2) && (
                  <li
                    className="items-option"
                    role="button"
                    onClick={() => {
                      // formik.setFieldValue("bookingStepName", "Buy a Membership");
                      dispatch(BookingStepName("BuySubscription"));
                      dispatch(NextStep(isBookingStep));
                    }}
                  >
                    <div className="d-flex justify-content-between align-items-center">
                      <h6 className="mb-0">
                        <a>
                          <img src={config.imagepath + "subscription-booking.png"} alt="" className="me-3" width="21" />
                          {t("Buy a Subscription")}
                        </a>
                      </h6>
                    </div>
                  </li>
                )}
              </ul>
            </div>
          </React.Fragment>
        </div>
      </div>
    </div>
  );
};

Step1.propTypes = {
  isBookingStep: PropTypes.number,
  isBookingSelectedServicesData: PropTypes.oneOfType([PropTypes.node, PropTypes.array, PropTypes.object]),
};
export default Step1;
